module.exports = __webpack_public_path__ + "static/media/arrowDown.20a878b2.svg";